// Radio options for the v3 → v2 nav opt-out survey, in render order.
// Each option's i18n key resolves to the user-facing label; `textAreaPlaceholderId`
// is the placeholder for the contextual "Tell us more (Optional)" textarea.
// `hideTextArea` opts out of the textarea entirely for the "I'm more familiar" path,
// matching the Figma spec where that choice has no follow-up prompt.
export type NavV3OptOutSurveyOptionValue =
  | 'moreFamiliar'
  | 'prefer'
  | 'cantFind'
  | 'notWorking'
  | 'other'

export type NavV3OptOutSurveyOption = {
  value: NavV3OptOutSurveyOptionValue
  labelId: string
  textAreaPlaceholderId?: string
  hideTextArea?: boolean
}

export const NAV_V3_OPT_OUT_SURVEY_OPTIONS: NavV3OptOutSurveyOption[] = [
  {
    value: 'moreFamiliar',
    labelId: 'navV3.optOutSurvey.option.moreFamiliar',
    hideTextArea: true,
  },
  {
    value: 'prefer',
    labelId: 'navV3.optOutSurvey.option.prefer',
    textAreaPlaceholderId: 'navV3.optOutSurvey.placeholder.prefer',
  },
  {
    value: 'cantFind',
    labelId: 'navV3.optOutSurvey.option.cantFind',
    textAreaPlaceholderId: 'navV3.optOutSurvey.placeholder.cantFind',
  },
  {
    value: 'notWorking',
    labelId: 'navV3.optOutSurvey.option.notWorking',
    textAreaPlaceholderId: 'navV3.optOutSurvey.placeholder.notWorking',
  },
  {
    value: 'other',
    labelId: 'navV3.optOutSurvey.option.other',
    textAreaPlaceholderId: 'navV3.optOutSurvey.placeholder.other',
  },
]
